<template>
  <div class="pbr-empty">
    <slot name="image">

    </slot>
    <template v-if="description">
      <p>
        {{ description }}}
      </p>
    </template>
    <template v-else>
      <p>
      {{ $t('noData') }}
      </p>
    </template>
  </div>
</template>

<script>
export default {
  name: 'Empty',
  props:{
    description:{
      type:String
    }
  },
  data () {
    return {

    }
  },
  methods: {

  },
  mounted () {

  }
}
</script>
<style scoped>
.pbr-empty {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  text-align: center;
  box-sizing: border-box;
  padding: 40px 0;
}
.pbr-empty p {
  font-size: 14px;
  color: #5e6d82;
  line-height: 1.5em;
}
</style>

